export const R = {
	"EditMyInformationLabelA11y": "Rediger mine informationer. Klik for at åbne vindue hvor du kan redigere email og telefonnummer.",
	"Name": "Navn",
	"Phone": "Telefon",
	"Email": "E-mail",
	"Edit": "Redigér",
	"Save": "Gem",
	"InvalidCpr": "Indtast venligst et gyldigt CPR‑nummer på 10 cifre.",
	"InvalidEmail": "Indtast venligst en gyldig e-mail.",
	"NetworkError": "Der opstod en fejl. Prøv venligst igen. {0}",
	"ErrorInvitePartner": "Kunne ikke invitere familiemedlemmet. ",
	"PartnerEmailRequired": "Familiemedlems e-mail skal udfyldes",
	"PartnerNameRequired": "Familiemedlems fulde navn skal udfyldes",
	"PartnerCprRequired": "Familiemedlems CPR-nummer skal udfyldes",
	"Active": "Aktiv",
	"Invited": "Inviteret",
	"NoPartner": "Ingen partner",
	"AlreadyHasPartner": "Patient har allerede en partner",
	"InvitePartner": "Inviter familiemedlem",
	"OpenDeleteHouseholdMemberModalA11y": "Fjern husstandsmedlem. Klik for at åbne vindue hvor du kan bekræfte sletning",
	"OpenEditPetModalA11y": "Rediger kæledyr. Klik for at åbne vindue hvor du kan redigere dit kæledyrs oplysninger.",
	"OpenDeletePetModalA11y": "Fjern kæledyr. Klik for at åbne vindue hvor du kan bekræfte sletning.",
	"AddPet": "Tilføj kæledyr",
	"EditPet": "Rediger kæledyr",
	"PetName": "Kæledyrets navn",
	"PetSex": "Køn og status",
	"PetRace": "Race (valgfri)",
	"PetRacePlaceholder": "f.eks. labrador",
	"PetBirthdate": "Fødselsmåned og -år",
	"PetBirthdateHint": "Er du i tvivl? Dit bedste bud er fint.",
	"PetType": "Kæledyrstype",
	"PetWeight": "Vægt i kilo (valgfri)",
	"PetWeightPlaceholder": "f.eks. 5,2 eller 5.2",
	"MonthJanuary": "Januar",
	"MonthFebruary": "Februar",
	"MonthMay": "Maj",
	"MonthMarch": "Marts",
	"MonthApril": "April",
	"MonthJune": "Juni",
	"MonthJuly": "Juli",
	"MonthAugust": "August",
	"MonthSeptember": "September",
	"MonthOctober": "Oktober",
	"MonthNovember": "November",
	"MonthDecember": "December",
	"SelectMonth": "Vælg måned",
	"SelectYear": "Vælg år",
	"PetSexMale": "Han",
	"PetSexFemale": "Hun",
	"PetSexMaleNeutered": "Kastreret han",
	"PetSexFemaleSterilized": "Steriliseret hun",
	"PetSexUnknown": "Ukendt",
	"PetTypeDog": "Hund",
	"PetTypeCat": "Kat",
	"PetTypeRabbit": "Kanin",
	"PetTypeRodent": "Gnaver",
	"SelectPetType": "Vælg kæledyrstype",
	"SelectPetSex": "Vælg køn",
	"ConfirmAddPet": "Gem",
	"ConfirmEditPet": "Opdater",
	"PleaseEnterPetName": "Indtast venligst dit kæledyrs navn",
	"PleaseSelectPetType": "Vælg venligst kæledyrstype",
	"PleaseSelectPetSex": "Vælg venligst køn",
	"PleaseChoosePetAge": "Vælg venligst dit kæledyrs fødselsdato. Det behøver ikke at være 100% nøjagtigt.",
	"PleaseSelectMonth": "Vælg venligst måned",
	"PleaseSelectYear": "Vælg venligst år",
	"RemovePet": "Fjern kæledyr",
	"RemovePetText": "Er du sikker på, at du vil fjerne dit kæledyr?",
	"KeepPet": "Behold kæledyr",
	"ErrorAddPet": "Der opstod en fejl under oprettelsen af dit kæledyr",
	"ErrorEditPet": "Der opstod en fejl under redigering af dit kæledyr",
	"ErrorDeletePet": "Der opstod en fejl under sletningen af dit kæledyr",
	"RemovePartner": "Fjern husstandsmedlem",
	"RemovePartnerText": "Er du sikker på, at du vil fjerne tilknytningen til dit husstandsmedlem? Dit husstandsmedlem vil stadig kunne bruge sin Hejdoktor-konto, men jeres delte adgang vil blive fjernet.",
	"KeepHouseholdMember": "Behold tilknytning",
	"RemoveHouseholdMember": "Fjern tilknytning",
	"Partner": "partner",
	"RemoveAccess": "Ja, fjern tilknytning",
	"ErrorDeletePartner": "Der opstod en fejl under sletningen af dit husstandsmedlem",
	"Profile_Description_Children": "Du kan kontakte os på vegne af dine mindreårige børn. Opret dem med CPR-nummer og navn her.",
	"Profile_AddChild": "Tilføj barn",
	"OpenEditChildModalA11y": "Rediger barn. Klik for at åbne et vindue, hvor du kan redigere dit barns oplysninger",
	"OpenDeleteChildModalA11y": "Fjern barn. Klik for at åbne et vindue, hvor du kan bekræfte sletning",
	"FullName": "Fulde navn",
	"CprNumber": "CPR-nummer",
	"ProfileConfirmAddKid": "Gem",
	"ProfileConfirmEditKid": "Gem",
	"Profile_EditChild": "Rediger barn",
	"PleaseEnterFullName": "Indtast venligst det fulde navn",
	"CprPlaceholder": "ddmmåå-xxxx",
	"CprRequired": "CPR skal udfyldes",
	"CprTooOld": "Beklager, denne funktionalitet er kun for børn under 18 år. Voksne skal logge ind med deres eget MitID for at bestille en konsultation.",
	"DeleteProfile": "Ja, slet profil",
	"RemoveChildText": "Er du sikker på, at du vil slette dit barns profil på Hejdoktor? Denne handling fjerner også barnets tidligere konsultationer. Bemærk venligst, at hvis du har bestilt en konsultation, er vi forpligtet til at gemme din information i mindst 10 år.",
	"KeepProfile": "Behold profil",
	"ConfirmCprIsCorrectHeader": "Er du sikker på, at CPR-nummeret er korrekt?",
	"CprModulusCheckWarning": "ligner ikke et gyldigt CPR-nummer. For at kunne journalføre og udstede recepter skal vi have det rigtige CPR-nummer. Tjek derfor venligst at CPR-nummeret er korrekt indtastet.",
	"Back": "Tilbage",
	"ConfirmAndSave": "Bekræft og gem",
	"RefreshDataError": "Siden kunne ikke opdateres. Genindlæs venligst.",
	"RemoveChild": "Slet børneprofil",
	"PleaseEnterANumber": "Indtast venligst et tal. Du må gerne bruge decimaler (fx 5,2 eller 5.2)"
}